// @owners { team: patients-team }
import { AddOnsEndpoint } from '@alto/scriptdash/alto/patient_app/add_ons/v1/add_ons_endpoint';
import { apiEndpointHandler } from '~shared/helpers/api';
import { useQuery } from '~shared/react-query';

const addOnsEndpoint = AddOnsEndpoint(apiEndpointHandler);

type QueryParams = {
  addressID: number | undefined;
  shipmentID: number | null | undefined;
};

export const useQueryRecommendedOtcs = ({ addressID, shipmentID }: QueryParams) => {
  const query = useQuery({
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @alto/prefer-query-key-factory
    queryKey: ['recommended-otcs', { addressID, shipmentID }],
    queryFn: () => {
      if (!addressID) return null;

      return addOnsEndpoint.fetchRecommended({
        address_id: addressID,
        shipment_id: shipmentID,
      });
    },
    refetchOnMount: false,
  });

  return {
    isSuccess: query.isSuccess,
    isLoading: query.isLoading,
    error: query.error,
    isError: query.isError,
    recommendedCategory: query.data?.data?.add_on_otc_category,
  };
};
